import { useState } from 'react';
import { ReactComponent as BlockedAlarmIcon } from '../../assets/imgs/chats/blocked-alarm-banner-icon.svg';
import { palette } from '../../theme/colors';
import { translate } from '../../utils/translate';
import { useIsSilentMode } from '../../utils/customHooks/useIsSilentMode';
import { SilentModeBottomSheet } from './SilentModeBottomSheet';
import { SContainer, SIcon, SLearnMore, STextColumn, STitle } from './SilentModeHeader.styles';

export const SilentModeHeader = () => {
  const isSilentMode = useIsSilentMode();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  if (!isSilentMode) return null;

  return (
    <>
      <SContainer onClick={() => setIsSheetOpen(true)}>
        <SIcon>
          <BlockedAlarmIcon fill={palette.gold} />
        </SIcon>
        <STextColumn>
          <STitle>{translate('silent_mode_banner_title')}</STitle>
          <SLearnMore>{translate('silent_mode_banner_learn_more')}</SLearnMore>
        </STextColumn>
      </SContainer>
      <SilentModeBottomSheet isOpen={isSheetOpen} setIsOpen={setIsSheetOpen} />
    </>
  );
};
